import React, { useState, useContext } from 'react';
import { styled } from '@this/constants/themes';
import { Box, Button, Link } from '@material-ui/core';
import axios from 'axios';
import AppointContext from '@this/components/appoint/appoint_context';
import { Coachmark } from '@this/components/appoint/shared/coachmark';

interface Props {
  theLeftBoxRef: React.MutableRefObject<HTMLDivElement | null>;
  inputFormRef: React.MutableRefObject<null>;
  suggestSettingButtonRef: React.MutableRefObject<null>;
  suggestButtonRef: React.MutableRefObject<null>;
}

const NewCoachMark: React.FC<Props> = ({
  theLeftBoxRef,
  inputFormRef,
  suggestSettingButtonRef,
  suggestButtonRef
}: Props) => {
  const initialNumber = 0;
  const lastNumber = 2;
  const [activatedNumber, setActivateNumber] = useState<number>(initialNumber);

  const contextValue = useContext(AppointContext);

  const NextCoachMark = async (indexNumber: number) => {
    // ステップ移行時に要素が自動スクロールしてハイライト位置がズレる現象への対応
    // 自動スクロールに先回りして十分にスクロールさせる。ステップ移行は下でsetTimeoutしている
    if (theLeftBoxRef && theLeftBoxRef.current) {
      theLeftBoxRef.current.scroll({ top: 500, behavior: 'smooth' });
    }
    if (indexNumber >= lastNumber) {
      await axios.post('/aicalendar.json', { need_coach_mark: '0' });
    }
    window.setTimeout(() => {
      setActivateNumber(indexNumber + 1);
    }, 200);
  };

  const NextButton = (
    <CoachMarkNextButton variant="contained" color="primary" onClick={() => NextCoachMark(activatedNumber)}>
      {activatedNumber === lastNumber ? '閉じる' : '次へ'}
    </CoachMarkNextButton>
  );
  const EndLink = (
    <EndLinkText>
      終了するには
      <Link onClick={() => NextCoachMark(lastNumber)} style={{ cursor: 'pointer' }}>
        ここをクリック
      </Link>
    </EndLinkText>
  );

  const InputFormCoachMark = (
    <CoachMarkWrap>
      <CoachMarkTitle>日程調整に必要な項目を入力</CoachMarkTitle>
      <CoachMarkDescription>
        予定の「タイトル」「時間(長さ)」などを選んで
        <br />
        予定を作成できる画面が出てきます。
      </CoachMarkDescription>
      <CoachMarkFooter>
        {EndLink}
        {NextButton}
      </CoachMarkFooter>
    </CoachMarkWrap>
  );
  const SuggestSettingButtonCoachMark = (
    <CoachMarkWrap>
      <CoachMarkTitle>自分の予定に合わせた細かな条件設定</CoachMarkTitle>
      <CoachMarkDescription>
        歯車マークから自動提案の詳細を設定することで、
        <br />
        よりあなたに合った予定をご提案します。
      </CoachMarkDescription>
      <CoachMarkFooter>
        {EndLink}
        {NextButton}
      </CoachMarkFooter>
    </CoachMarkWrap>
  );
  const SuggestButtonCoachMark = (
    <CoachMarkWrap>
      <CoachMarkTitle>AIが自動で候補日の提案</CoachMarkTitle>
      <CoachMarkDescription>
        AIカレンダーの特徴は「候補日を自動で抽出」を使うと、
        <br />
        予定の候補日程を自動で提案。あとは作成＆シェアするだけ。
      </CoachMarkDescription>
      <CoachMarkFooter>{NextButton}</CoachMarkFooter>
    </CoachMarkWrap>
  );

  const coachList: React.ComponentProps<typeof Coachmark>[] = [
    {
      show: activatedNumber === initialNumber,
      renderContent: () => InputFormCoachMark,
      targetRef: inputFormRef,
      popupPlacement: contextValue.isMobile ? 'bottom' : 'right'
    },
    {
      show: activatedNumber === initialNumber + 1,
      renderContent: () => SuggestSettingButtonCoachMark,
      targetRef: suggestSettingButtonRef,
      popupPlacement: contextValue.isMobile ? 'left' : 'right'
    },
    {
      show: activatedNumber === lastNumber,
      renderContent: () => SuggestButtonCoachMark,
      targetRef: suggestButtonRef,
      popupPlacement: contextValue.isMobile ? 'top' : 'right'
    }
  ];
  const coach = coachList[activatedNumber];

  return coach ? <Coachmark {...coach} /> : null;
};

const CoachMarkWrap = styled(Box)`
  padding: 10px;
`;

const CoachMarkTitle = styled.p`
  color: #243565;
  font-weight: bold;
  margin: 0 0 10px;
`;

const CoachMarkDescription = styled.p`
  font-size: 11px;
  margin: 0 0 20px;
`;

const CoachMarkFooter = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CoachMarkNextButton = styled(Button)`
  margin-left: auto;
`;

const EndLinkText = styled.span`
  font-size: 11px;
`;

export default NewCoachMark;
